/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlImpersonationDetails
 */
export interface ControlImpersonationDetails {
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_creation_date: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_last_logged_in?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_job_function?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonationDetails
     */
    target_user_email: string;
}

/**
 * Check if a given object implements the ControlImpersonationDetails interface.
 */
export function instanceOfControlImpersonationDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_user_creation_date" in value;
    isInstance = isInstance && "target_user_id" in value;
    isInstance = isInstance && "target_user_email" in value;

    return isInstance;
}

export function ControlImpersonationDetailsFromJSON(json: any): ControlImpersonationDetails {
    return ControlImpersonationDetailsFromJSONTyped(json, false);
}

export function ControlImpersonationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlImpersonationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target_user_creation_date': json['target_user_creation_date'],
        'target_user_last_logged_in': !exists(json, 'target_user_last_logged_in') ? undefined : json['target_user_last_logged_in'],
        'target_user_first_name': !exists(json, 'target_user_first_name') ? undefined : json['target_user_first_name'],
        'target_user_last_name': !exists(json, 'target_user_last_name') ? undefined : json['target_user_last_name'],
        'target_user_job_function': !exists(json, 'target_user_job_function') ? undefined : json['target_user_job_function'],
        'target_user_id': json['target_user_id'],
        'target_user_email': json['target_user_email'],
    };
}

export function ControlImpersonationDetailsToJSON(value?: ControlImpersonationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_user_creation_date': value.target_user_creation_date,
        'target_user_last_logged_in': value.target_user_last_logged_in,
        'target_user_first_name': value.target_user_first_name,
        'target_user_last_name': value.target_user_last_name,
        'target_user_job_function': value.target_user_job_function,
        'target_user_id': value.target_user_id,
        'target_user_email': value.target_user_email,
    };
}

